import { schemeDark2 } from 'd3-scale-chromatic'
import { scaleOrdinal } from 'd3-scale'

const colors = scaleOrdinal(schemeDark2)

export default colors